// src/components/AboutJourney/AboutJourney.js
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import settingsIcon from "../../../assets/About/Journey/SVG.png";

import "./AboutJourney.css";

// Import Images (Replace with your actual assets)
import img1 from "../../../assets/About/Journey/history-image-1.jpg.png";
import img2 from "../../../assets/About/Journey/history-image-1.jpg(4).png";
import img3 from "../../../assets/About/Journey/history-image-1.jpg (1).png";
import img4 from "../../../assets/About/Journey/history-image-1.jpg (2).png";
import img5 from "../../../assets/About/Journey/history-image-1.jpg (3).png";


const AboutJourney = () => {


  // --- DATA: Timeline Content ---
  const journeyData = [
    {
      id: 1,
      navLabel: "The Foundation of Dynamic Stamping",
      // CHANGED: Matches image design (Regular + Bold Span)
      title: (
        <span style={{ fontWeight: "300" }}>
          The Foundation of{" "}
          <span style={{ fontWeight: "700" }}>Dynamic Stamping</span>
        </span>
      ),
      description:
        "Dynamic Stamping was established in 2005 in Perungudi, Chennai, with a focused vision to manufacture precision automotive stamped components. Operations commenced with two press machines and ten automotive parts, supplying as a third-tier vendor to Ford, marking our entry into the OEM supply chain.",
      points: [
        "Company founded in 2005",
        "Initial setup with 2 stamping presses",
        "Production of 10 automotive components",
        "Entry into the OEM supply ecosystem",
      ],
      img: img1,
    },
    {
      id: 2,
      navLabel: (<p className="navLabel">Early Growth & Tool Room Establishment<br />(2006–2009)</p>),
      title: (
        <span style={{ fontWeight: "300" }}>
          Early Growth &{" "}
          <span style={{ fontWeight: "700" }}>Capability Expansion</span>
        </span>
      ),
      description:
        "Between 2006 and 2009, Dynamic Stamping strengthened its manufacturing base by expanding press capacity and, most importantly, establishing a fully functional in-house tool room. This strategic investment enabled faster product development, tool control, and enhanced quality assurance.",
      points: [
        "In-house tool room established (core capability)",
        "Expansion of press capacity",
        "Introduction of DRO milling & surface grinding",
        "Vendor onboarding: Caparo, PSPL, Fritzmeier, Seco Komos",
        "ISO 9001 Quality Management System initiated",
      ],
      img: img2,
    },
    {
      id: 3,
      navLabel: (<p className="navLabel">Process Strengthening & Quality Certifications <br />(2009–2013)</p>),
      title: (
        <span style={{ fontWeight: "300" }}>
          Process{" "}
          <span style={{ fontWeight: "700" }}>
            {" "}
            Strengthening & Certifications
          </span>
        </span>
      ),
      description:
        "From 2009 to 2013, the company focused on process discipline, quality excellence, and capacity enhancement. Advanced machining and welding infrastructure were added to support higher volumes and tighter tolerances.Dynamic Stamping achieved ISO / TS 16949 certification, reinforcing its commitment to automotive quality standards.",
      points: [
        "ISO / TS 16949 certification achieved",
        "CNC wire cut, VMC milling & spot welding installed",
        "Consistent 100 PPM quality performance",
        "Expansion to Mannur manufacturing facility",
      ],
      img: img3,
    },
    {
      id: 4,
      navLabel: (<p className="navLabel">Scaling Operations & Global OEM Partnerships<br />  (2014–2019)</p>),
      title: (
        <span style={{ fontWeight: "300" }}>
          Scaling Operations &
          <span style={{ fontWeight: "700" }}> Global OEM Partnerships </span>
        </span>
      ),
      description:
        "Between 2014 and 2019, Dynamic Stamping expanded its operational footprint and customer base, strengthening its position as a reliable Tier-1 and Tier-2 automotive supplier. High-capacity presses and supporting infrastructure enabled the company to meet global OEM requirements.",
      points: [
        "High-capacity stamping presses up to 315 tons",
        "IATF 16949:2016 certification",
        "Global OEM and Tier-1 customer additions",
        "Warehouse and facility expansion (3000+ sq. ft.)",
        "Introduction of coil feeders & injection moulding",
      ],
      img: img4,
    },
    {
      id: 5,
      navLabel: (<p className="navLabel">Automation, Innovation & Future Readiness<br /> (2020–Present)</p>),
      title: (
        <span style={{ fontWeight: "300" }}>
          Automation, Innovation &
          <span style={{ fontWeight: "700" }}> Future Readiness</span>
        </span>
      ),
      description: "From 2020 onwards, Dynamic Stamping has focused on automation, digital quality systems, and future-ready manufacturing. Investments in robotic welding, vision inspection, and advanced testing systems reinforce our commitment to precision, consistency, and scalability.",
      points: [
        "Robotic welding & vision inspection systems",
        "UTM and advanced testing facilities",
        "New customer onboarding including Yanfeng",
        "Plant II expansion planned (24,000 sq. ft.)",
      ],
      img: img5,
    },
  ];

  // State to track active timeline item
  const [activeTab, setActiveTab] = useState(journeyData[0]);

  // State to track window width
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  // Update state on resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="about-journey-section" id="about-journey">
      <Container>
        {/* Header Row */}
        <Row className="mb-5">
          <Col lg={6}>
            <span className="aj-label">Our Journey</span>
            <h2 className="aj-heading">
              Our Journey of Growth &<br />
              <span className="aj-headingor"> Manufacturing Excellence</span>
            </h2>
          </Col>
          <Col
            lg={6}

            className="d-flex align-items-center"
          >
            <p className="aj-desc-top">
              Dynamic Stamping Pvt. Ltd. is a precision automotive component manufacturer with over two decades of experience, built on strong engineering fundamentals, robust in-house tooling capability, and uncompromising quality standards.
              From a modest beginning with two press machines, the company has evolved into a trusted Tier-1 and Tier-2 supplier to leading automotive OEMs, delivering consistent quality, scalability, and long-term value.
            </p>
          </Col>
        </Row>

        {isMobile ? (
          /* MOBILE VIEW: Stacked Layout */
          <div className="journey-mobile-stacked">
            {journeyData.map((item) => (
              <div key={item.id} className="journey-mobile-item">
                <div className="journey-mobile-header">
                  <span className="nav-year">{item.navLabel}</span>
                </div>
                <div className="journey-content-panel">
                  <h3 className="content-title">{item.title}</h3>
                  <div className="content-col-img mb-3">
                    <img
                      src={item.img}
                      alt="Journey Milestone"
                      className="journey-dynamic-img"
                    />
                  </div>
                  <p className="content-desc">{item.description}</p>
                  <ul className="content-points">
                    {item.points.map((point, index) => (
                      <li key={index} className="point-item">
                        <img
                          src={settingsIcon}
                          alt="icon"
                          className="point-icon"
                          style={{
                            width: "20px",
                            height: "20px",
                            objectFit: "contain",
                          }}
                        />
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        ) : (
          /* DESKTOP VIEW: Tabbed Layout */
          <Row>
            {/* LEFT: Navigation List */}
            <Col lg={4} md={12} className="mb-4 mb-lg-0">
              <div className="journey-nav-list">
                {journeyData.map((item) => (
                  <div
                    key={item.id}
                    className={`journey-nav-item ${activeTab.id === item.id ? "active" : ""}`}
                    onClick={() => setActiveTab(item)}
                    style={{ marginBottom: "0px" }}
                  >
                    <span className="nav-year">{item.navLabel}</span>
                  </div>
                ))}
              </div>
            </Col>

            {/* RIGHT: Dynamic Content Panel */}
            <Col lg={8} md={12}>
              <div
                className="journey-content-panel fade-in-up"
                key={activeTab.id}
              >
                <Row className="align-items-start">
                  {/* Text Content */}
                  <Col lg={7} md={12} className="content-col-text">
                    <h3 className="content-title">{activeTab.title}</h3>
                    <p className="content-desc">{activeTab.description}</p>

                    <ul className="content-points">
                      {activeTab.points.map((point, index) => (
                        <li key={index} className="point-item">
                          <img
                            src={settingsIcon}
                            alt="icon"
                            className="point-icon"
                            style={{
                              width: "20px",
                              height: "20px",
                              objectFit: "contain",
                            }}
                          />
                          {point}
                        </li>
                      ))}
                    </ul>
                  </Col>

                  {/* Image Content */}
                  <Col lg={5} md={12} className="content-col-img">
                    <img
                      src={activeTab.img}
                      alt="Journey Milestone"
                      className="journey-dynamic-img"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
};

export default AboutJourney;
